import React from 'react';
import { Sparkles, Home } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSelection } from '../context/SelectionContext';
import { ThemeToggle } from './ThemeToggle';

export const Header: React.FC = () => {
  const { resetSelection } = useSelection();

  return (
    <header className="header">
      <div className="header-content">
        <motion.div 
          className="flex items-center space-x-2"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Sparkles className="text-indigo-600 dark:text-indigo-400" size={28} />
          <h1 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-gray-100">AI Tool Finder</h1>
        </motion.div>
        <div className="flex items-center space-x-3">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={resetSelection}
            className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 transition-colors"
            aria-label="Home"
          >
            <Home size={20} />
          </motion.button>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};